import _ from 'lodash';
import { message } from 'antd';
import Emitter from '../../services/emitter';
import History from '../../util/history';
import CONSTANT from '../../constant';

import Mscratch from '../../services/mscratch';
import { connectState, firmwareState } from '../../services/mscratch/connect';
import { getTargetDevices } from '../../services/mscratch/ext';
import ConnectAction from '../connect/action';
import Connect from '../../services/connect';

export default (store) => {
    /**
     * codey 连接成功
     *
     * @param {any} device
     * @param {any} connectType
     * @param {any} isConnected
     * @returns
     */
    const codeyConnected = async (device, connectType, isConnected) => {

    };

    /**
     * 连接成功日志
     *
     * @param {any} deviceName
     * @param {any} connectType
     * @param {any} isConnected
     */
    const logConnected = (deviceName, connectType, isConnected) => {
        if (isConnected !== true) {
            Emitter.emit('LogConnectDevice', { name: deviceName }, true, connectType);
        }
    };

    /**
     * device connect success handle function
     *
     * @param {any} device
     */
    const onDeviceConnected = (device, connectType, isConnected) => {
        if (!device) {
            console.log('listeners.connect.onDeviceConnected Device is null');
            return;
        }
        //下面的代码是串口的wirte和on传递的数据转换为buffer和标准node-serialport等价，主要给第三方驱动库使用，比如stk500等
        let serial = device.rawPort;
        let rawSerialport = _.extend({}, serial, {
            dataEventMap: {},
            write: function (buffer, callback) {
                if (Buffer.isBuffer(buffer)) {
                    let tmp = [];
                    for (let i = 0; i < buffer.length; ++i) {
                        tmp[i] = buffer[i];
                    }
                    serial.write(tmp, 'utf8', callback);
                } else {
                    serial.write(buffer, 'utf8', callback);
                }
            },
            on: (event, handle) => {
                if (event == 'data') {
                    let h = (data) => {
                        //TODO 后续逐步统一规范，不再做各种兼容
                        if (data instanceof Array) {
                            let buffer = new Buffer(data.length);
                            for (let i = 0; i < buffer.length; ++i) {
                                buffer[i] = data[i];
                            }
                            handle(buffer);
                        } else if (data.type == 'Buffer' && data.data instanceof Array) {
                            let buffer = new Buffer(data.data.length);
                            for (let i = 0; i < buffer.length; ++i) {
                                buffer[i] = data.data[i];
                            }
                            handle(buffer);
                        } else {
                            console.error('Cannot convert data to buffer ', data);
                            handle(null);
                        }
                    };
                    rawSerialport.dataEventMap[handle.name] = h;
                    return serial.on('data', h);
                } else {
                    return serial.on(event, handle);
                }
            },
            removeListener: (event, handle) => {
                if (event == 'data') {
                    let h = rawSerialport.dataEventMap[handle.name];
                    serial.removeListener(event, h);
                } else {
                    serial.removeListener(event, handle);
                }
            },
            open: (callback) => {
                serial.open(callback);
            },
            set: (options, callback) => {
                serial.set(options, callback);
            },
            close: (callback) => {
                serial.close(callback);
            },
            drain: async (callback) => {
                await serial.drain(callback);
            },
            flush: async (callback) => {
                await serial.flush(callback);
            }
        });
        //TODO 重构掉
        Mscratch.setTransporterRawPort(rawSerialport);
        window.currentPort = rawSerialport;

        //连接好设备后，开始监听数据
        (() => {
            const { connect } = store.getState();
            let connectionId = connect.connectionInfo && connect.connectionInfo.connectionId;
            Connect.addDataListener(connect.type, connectionId,
                (data) => {
                    // console.log('listener.mscrach receive data ', null, data);
                    Emitter.emit('ConnectReceive', null, data);
                }
            );
            Connect.addErrorListener(connect.type, connectionId,
                (err, isBroken = true) => {
                    console.warn('listener.mscrach receive error ', err);
                    Emitter.emit('ConnectBroken', { address: connectionId }, isBroken);
                }
            );


        })();

        Emitter.emit('SyncConnectState', CONSTANT.SYNC_CONNECT_STATE_TYPE.CONNECTED, device, connectType);
        // connectState(device, true);
        if (device.deviceId.toLowerCase() === CONSTANT.DEVICE.CODEY) {
            codeyConnected(device, connectType, isConnected);
        } else {
            logConnected(device.deviceId, connectType, isConnected);
        }
    };

    /**
     * 设备断开连接事件
     *
     * @param {any} device
     */
    const onDeviceDisconnected = (device, type, isBroken = false) => {
        if (isBroken) {
            const { connect } = store.getState();
            const { devices } = connect;
            if (!_.isEmpty(devices) && device) {
                device = _.find(devices, { address: device.address });
            }
        }
        if (device && device.deviceId && device.name) {
            connectState(device, false, type);
            firmwareState(device, false);
            // 记录是否断开连接设备
            Emitter.emit('LogDisconnectDevice', device, isBroken ? 'passive' : '');
        }
    };

    // /**
    //  * 检查设置 需要禁用的块
    //  * @param {int} type <0:render | 1: project update>
    //  */
    // const onCheckDisableBlocks = (type) => {
    //     clearTimeout(disableBlocksDelayTimer);
    //     disableBlocksDelayTimer = setTimeout(() => {
    //         const { isLogin } = store.getState().account;
    //         if (!isLogin) {
    //             Mscratch.disableBlocks(CONSTANT.LOGIN_AVAILABLE_BLOCKS);
    //         } else {
    //             Mscratch.enableBlocks(CONSTANT.LOGIN_AVAILABLE_BLOCKS);
    //         }
    //     }, type === 0 ? 1000 : 100);
    // };

    /**
     * 设备被动断开连接触发事件
     */

    const onConnectBroken = (device, isBroken = true) => {
        const { connect, intlr } = store.getState();
        store.dispatch(ConnectAction.disconnect(connect.type, connect.connectionInfo && connect.connectionInfo.connectionId, device, isBroken));
        if (isBroken) {
            message.warning(intlr.messages['CONNECT.STATUS.DISCONNECTED']);
            History.replace('/');
        }
    };

    /**
     * 服务连接成功执行事件
     *
     */
    const onServerConnected = (err, data) => {
        const { type } = store.getState().connect;
        store.dispatch(ConnectAction.status(type));
        Mscratch.resize();
        if (!data) {
            Emitter.emit('SyncConnectState', CONSTANT.SYNC_CONNECT_STATE_TYPE.SERVER_OFFLINE, false);
        }
    };

    /**
     * 固件上传完成事件
     *
     */
    const onUploadFirmwareComplete = (device, isOk, isRetry) => {
        // onConnectBroken(device, false);
        Emitter.emit('LogUpdateFirmware', isOk, isRetry ? '' : '');
    };

    /**
     * 检查固件版本是否匹配
     *
     * @param {any} { version } isGoodCodey,
     */
    const onCheckFirmwareVersion = async (device, { info }) => {
        console.log({ onCheckFirmwareVersion: device, info });
        try {
            // let isMatch = false;
            // if (!_.isEmpty(info)) {
            //     const { codey } = await UpdaterAction.getFirmwareVersion();
            //     isMatch = codey && codey.last === info.version;
            // }
            // info.isMatch = isMatch;
            // 设备信息
            store.dispatch(ConnectAction.setDeviceInfo({ ...device, firmware: info }));
            // firmwareState(device, !isMatch);
            // if (!isMatch && isGoodCodey) {
            //     // 如果当前页面为软件更新页面
            //     if ('/' === History.location.pathname) {
            //         // 提示固件不匹配
            //         History.push('/updater/firmware/notmatch');
            //     }
            // }
        } catch (err) {
            console.warn(err);
        }
    };

    const onSyncConnectState = (state, device, type) => {
        // 断开所有
        if (device === false) {
            const targets = getTargetDevices();
            targets.forEach(target => {
                connectState(target, false, type);
            });
        } else {
            const {
                devices
            } = store.getState().connect;
            if (state === CONSTANT.SYNC_CONNECT_STATE_TYPE.CONNECTED) {
                if (_.isObject(device) && _.isEmpty(devices)) {
                    connectState(device, true, type);
                } else {
                    const targets = getTargetDevices();
                    let connectTarget = null;
                    targets.forEach(target => {
                        if (target.name === device.name) {
                            connectTarget = target;
                        } else {
                            connectState(target, false, type);
                        }
                    });
                    connectTarget && connectState(connectTarget, true, type);
                }
            }
        }
    };

    // 服务启动成功
    Emitter.on('ServerConnected', onServerConnected);
    // 连接被断开
    Emitter.on('ConnectBroken', onConnectBroken);
    // 设备连接成功
    Emitter.on('DeviceConnected', onDeviceConnected);
    // 设备断开连接成功
    Emitter.on('DeviceDisconnected', onDeviceDisconnected);
    // 检查语句块的禁用状态
    // Emitter.on('CheckDisableBlocks', onCheckDisableBlocks);
    // 上传固件成功
    Emitter.on('UploadFirmwareComplete', onUploadFirmwareComplete);
    // 检查固件版本
    Emitter.on('CheckFirmwareVersion', onCheckFirmwareVersion);
    // 同步连接状态
    Emitter.on('SyncConnectState', onSyncConnectState);
};